import { English } from './en-CA'
import { German } from './de-DE'
import { Spanish } from './es-MX'
import { French } from './fr-FR'
import { Hungarian } from './hu-HU'
import { Italian } from './it-IT'
import { Polish } from './pl-PL'
import { Portuguese } from './pt-BR'
import { Swedish } from './sv-SE'

const keyboardList = {
  "en-CA": English,
  "de-DE": German,
  "es-MX": Spanish,
  "fr-FR": French,
  "hu-HU": Hungarian,
  "it-IT": Italian,
  "pl-PL": Polish,
  "pt-BR": Portuguese,
  "sv-SE": Swedish,
}

export default keyboardList
